import _ from "lodash"

import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { IScoring } from "./asset"
import { SimpleRuleItem } from "../simple-rule"

export class SliderOptionsVM extends CommonOptionVM {
  min?: number
  max?: number
  step?: number
  default_value?: number
  grouping_separator?: boolean
  unit_type?: string
  units?: string[]
  required?: boolean
  require_media?: boolean
  require_note?: boolean
  simple_rule?: SimpleRuleItem[];
  enable_score?: boolean;
  scoring?: IScoring;

  constructor(data: Partial<SliderOptionsVM> = {}) {
    super(data)
    this.min = data?.min || undefined
    this.max = data?.max || undefined
    this.step = data?.step || undefined
    this.default_value = data?.default_value || undefined
    this.grouping_separator = data?.grouping_separator ?? undefined
    this.unit_type = data?.unit_type ?? undefined
    this.units = data.units ?? undefined
    this.required = data?.required ?? undefined
    this.require_media = data?.require_media ?? undefined
    this.require_note = data?.require_note ?? undefined
    this.simple_rule = data.simple_rule ? _.map(data.simple_rule, x => new SimpleRuleItem(x as any)) : undefined

    this.enable_score = data.enable_score ?? undefined
    this.scoring = this.enable_score ? {
      min_point: this.scoring?.min_point ?? 0,
      max_point: this.scoring?.max_point ?? null,
      scoring_weight: this.scoring?.scoring_weight ?? 1
    } : undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    if (this.min === null) {
      errors.push({ key: 'min', error_message: 'Min value is required' })
    }
    if (this.max === null) {
      errors.push({ key: 'max', error_message: 'Max value is required' })
    }
    if (this.step === null) {
      errors.push({ key: 'step', error_message: 'Step value is required' })
    }
    if (this.min && this.max && this.min >= this.max) {
      errors.push({ key: 'min', error_message: 'Min value must be less than max value' })
    }
    if (this.step && this.step <= 0) {
      errors.push({ key: 'step', error_message: 'Step value must be greater than 0' })
    }
    if (this.step && this.max && this.step >= this.max) {
      errors.push({ key: 'step', error_message: 'Step value must be less than max value' })
    }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default SliderOptionsVM